<template>
  <!--分组管理-->
  <div id="mainDateList">
    <div>
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div>
            <p>
              <input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="分组名称" v-model="postData.Name">
            </p>
            <!-- <p>
            <select  class="allSelect" v-model="postData.depart">
            <option value="" selected>请选择部门</option>
            </select>
            </p> -->
            <p>
              <button class="redButton" @click="getAll(1)">
                搜索
              </button>
            </p>
          </div>
          <div style="width: auto">
            <!-- <button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('AppOwner') >= 0 || isSystemAdmin === 'true'">添加</button> -->
            <button class="redButton m_r_10" @click="editToUrl ()">新建分组</button>
            <!-- <button class="redButton m_r_10" @click="addNewSend ()">新建推送</button> -->
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <div>
          <!-- <nav class="t_r m_b_10"><button class="redButtonTwo" @click="editToUrl()" v-if="nowApp.roles.indexOf('ContentEditor') >= 0">添加</button></nav> -->
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>分组名称</th>
<!--              <th>分组类型</th>-->
              <th class="t_c">分组人数</th>
<!--              <th>组管理员</th>-->
              <th>创建时间</th>
              <th>描述</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td>{{item.name}}</td>
<!--              <td>{{item.type}}</td>-->
              <td class="t_c">{{item.userCount}}</td>
<!--              <td :title="item.admins" class="NoWrap" style="max-width: 200px">{{item.admins}}</td>-->
              <td :title="item.admins" class="NoWrap" style="max-width: 200px">{{item.creationTime}}</td>
              <td :title="item.admins" class="NoWrap" style="max-width: 200px">{{item.description}}</td>
              <!-- <td>{{item.creationTime.split('T')[0]}}</td> -->
              <!-- <td :title="item.description" width="15%" style="max-width: 300px;;padding-right: 10px" class="NoWrap">{{item.description}}</td> -->
              <td width="10%"><div class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="editGroup(item)">编辑</li>
                  <li  @click="removeGroup(item.id)">删除</li>
<!--                  <li @click="exportGroup(item.id, item.name)">导出</li>-->
<!--                  <li @click="getDominList(1, item)">查看成员</li>-->

                </ul>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" v-on:on-getList="getAll($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
    </div>
    <sendPicker v-model="showSendPicker"></sendPicker>
    <model v-if="dominUserModel" :buttonType="1" :title="'查看成员'" :minWidth="'1000px'" v-on:on-cancel="cancelModel()">
      <div class="allSearch" style="margin-top: 0px!important;">
        <div class="newSearch d_flex">
          <div style="white-space: normal;">
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" placeholder="姓名" v-model="newDominList.name">
            </p>
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" placeholder="工作邮箱" v-model="newDominList.email">
            </p>
            <p>
              <input @keyup.enter="getDominList(1)" class="allInput" type="text" placeholder="部门" v-model="newDominList.org_Acronym">
            </p>
          </div>
          <div style="width: auto;">
            <button class="redButtonTwo" @click="getDominList(1)">搜索</button>
          </div>
        </div>
      </div>
      <table cellspacing="0" class="allTable alltableHui">
        <thead>
        <tr style="background-color: #FBFBFB;color: #797979">
          <th>姓名</th>
          <th class="t_c">性别</th>
          <th>工作邮箱</th>
          <th>分公司</th>
          <th>所在地</th>
          <th>地址</th>
          <th>部门</th>
          <th>已关注</th>
        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(item, index) in dominUserList">
          <td width="5%" class="NoWrap" style="max-width: 30px" :title="item.name">{{item.name}}</td>
          <td width="5%" class="t_c NoWrap" :title="$commonJs.getGender(item.gender)">{{$commonJs.getGender(item.gender)}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.email">{{item.email}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.company_Name">{{item.company_Name}}</td>
          <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.location">{{item.location}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.building_Long">{{item.building_Long}}</td>
          <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.org_Acronym">{{item.org_Acronym}}</td>
          <td width="5%">{{item.isAttention ? '已关注': '未关注'}}</td>
        </tr>
        </tbody>
      </table>
      <page v-if="dominUserList !== 0" v-on:on-getList="getDominList($event)" :totalCount="allPageDto.allDominListTotalCount" :totalPage="allPageDto.allDominListTotalPage" :page="allPageDto.allDominListPage" :explain="0"></page>
    </model>
  </div>
</template>

<script>
export default {
  name: 'mainDateList',
  data () {
    return {
      baseUrl: process.env.config.baseUrl,
      dominUserList: [],
      showSendPicker: false,
      dominUserModel: false,
      allPageDto: {
        allDominListTotalPage: 0,
        allDominListTotalCount: 0,
        allDominListPage: 1
      },
      OpenModel: false,
      showModel: false,
      title: '',
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        Name: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      newDominList: {
        name: '',
        email: '',
        org_Acronym: '',
        domninId: 0,
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin')
    }
  },
  created () {
    this.getAll(1)
  },
  methods: {
    clearModel () {
      this.postData = {
        ID: '',
        title: '',
        ContentTypeIds: '',
        startdate: '',
        enddate: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize
      }
    },
    // 查看成员
    getDominList (PageNum, object) {
      if (object) {
        this.dominUserModel = true
        this.newDominList.domninId = object.id
        this.newDominList.groupId = object.id
      }
      this.allPageDto.allDominListPage = PageNum
      this.newDominList.PageIndex = PageNum
      let url = this.$commonJs.returnQuery('/api/Group/GetWechatUserByGroup', this.newDominList)
      this.$axiox.get(url).then(msg => {
        this.dominUserList = msg
        // this.allPageDto.allDominListTotalPage = Math.ceil(msg.result.totalCount / this.newDominList.PageSize)
        // this.allPageDto.allDominListTotalCount = msg.result.totalCount
      })
    },
    addNewSend () {
      this.showSendPicker = true
    },
    // 新建
    editToUrl () {
      this.$router.push({
        name: 'editMainDateList',
        query: {
          id: 0
        }
        // params: {
        //   id: 0
        // }
      })
    },
    getList (PageNum) {
      this.postData.PageIndex = PageNum
      let url = this.$commonJs.returnQuery('/api/Group/GetGroupList', this.postData)
      this.$axiox.getList(url).then(msg => {
        this.page = PageNum
        // console.log(msg)
        this.myList = msg.data
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    editGroup (item) {
      this.$router.push({
        name: 'editMainDateList',
        query: {
          id: item.id,
          name: item.name,
          type: 'edit'
        }
      })
    },
    selectMainDate () {
      console.log(name.length)
      // if(this.postData.name.length===0){
      //   this.getAll(1)
      // }
      // else{
      //   this.getList(1)
      // }
    },
    getAll (PageNum) {
      this.postData.PageIndex = PageNum
      let url = this.$commonJs.returnQuery('/api/Group/GetByName', this.postData)
      this.$axiox.getList(url).then(msg => {
        this.page = PageNum
        console.log(msg)
        this.myList = msg.data
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    removeGroup (id) {
      this.$commonJs.doubleComfirm({
        content: '是否确定删除此分组？',
        successFun: msg => {
          this.$axiox.get('/api/Group/Delete?Id=' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAll(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    exportGroup (id, name) {
      var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      xmlResquest.open('GET', this.baseUrl + '/api/Group/' + id + '/export?groupName=' + encodeURIComponent(name), true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('token'))
      xmlResquest.setRequestHeader('AppId', window.sessionStorage.getItem('AppId'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = name + '.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      // this.$axiox.get('/api/Group/' + id + '/export?groupName=' + name).then(msg => {
      // })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
      this.dominUserModel = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/mainDateList.vue